var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"5":1,"95":1,"280":1,"295":1,"458":1,"633":1,"683":1,"788":1,"857":1,"942":1,"985":1,"1031":1,"1054":1,"1086":1,"1128":1,"1338":1,"1457":1,"1486":1,"1509":1,"1514":1,"1617":1,"1734":1,"1773":1,"2020":1,"2362":1,"2386":1,"2450":1,"2518":1,"2693":1,"2730":1,"2827":1,"2948":1,"2950":1,"3024":1,"3132":1,"3161":1,"3209":1,"3360":1,"3424":1,"3596":1,"3606":1,"3727":1,"3751":1,"3786":1,"3834":1,"4344":1,"4410":1,"4415":1,"4420":1,"4430":1,"4469":1,"4472":1,"4494":1,"4583":1,"4792":1,"4808":1,"4818":1,"4874":1,"4890":1,"4976":1,"5003":1,"5010":1,"5147":1,"5180":1,"5246":1,"5271":1,"5536":1,"5594":1,"5642":1,"5828":1,"5862":1,"5994":1,"6073":1,"6303":1,"6305":1,"6344":1,"6412":1,"6520":1,"6529":1,"6551":1,"6576":1,"6606":1,"6673":1,"6714":1,"6932":1,"6952":1,"6962":1,"7024":1,"7318":1,"7354":1,"7441":1,"7508":1,"7528":1,"7597":1,"7604":1,"7640":1,"7662":1,"7712":1,"7968":1,"8096":1,"8214":1,"8376":1,"8394":1,"8487":1,"8507":1,"8512":1,"8677":1,"8713":1,"8722":1,"8773":1,"8898":1,"8917":1,"8928":1,"8932":1,"8990":1,"9045":1,"9053":1,"9054":1,"9061":1,"9064":1,"9293":1,"9314":1,"9406":1,"9410":1,"9532":1,"9556":1,"9662":1,"9759":1,"9777":1,"9866":1,"9881":1,"9900":1,"9915":1,"9945":1,"9979":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr